import blog1 from "../../images/blog-1.png"
import clientblog from "../../images/blog-client.png"
import arroeNerrowRignt from "../../images/arrow-narrow-right.png"
import blog2 from "../../images/blog-2.png"
import blogClient2 from "../../images/blog-client-2.png"
import blog3 from "../../images/blog-3.png"
import blogClient3 from "../../images/blog-client-3.png"
import blog4 from "../../images/blog-4.png"
import blog5 from "../../images/blog-5.png"
import blog6 from "../../images/blog-6.png"
import blog7 from "../../images/blog-7.png"
import blog8 from "../../images/blog-8.png"
import blog9 from "../../images/blog-9.png"
import blogList1 from "../../images/blog-list-1.png"
import blogList2 from "../../images/blog-list-2.png"
import blogList3 from "../../images/blog-list-3.png"
import blogList4 from "../../images/blog-list-4.png"



export const BlogData = [
    {
        id : 1,
        img : blog1,
        img2 : blogList1,
        date : "22 Sep",
        year : "2022",
        title : "25 Essential High School Reads From the Last Decade",
        clientImg : clientblog,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."

    },
    {
        id : 2,
        img : blog2,
        img2 : blogList2,
        date : "22 Sep",
        year : "2022",
        title : "Having Students Learn by Teaching",
        clientImg : blogClient2,
        desg : "By.Developer",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 3,
        img : blog3,
        img2 : blogList3,
        date : "22 Sep",
        year : "2022",
        title : "Cultivating Curiosity Among Older Students",
        clientImg : blogClient3,
        desg : "By.Designer",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 4,
        img : blog4,
        img2 : blogList4,
        date : "22 Sep",
        year : "2022",
        title : "25 Essential High School Reads From the Last Decade",
        clientImg : clientblog,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 5,
        img : blog5,
        img2 : blogList1,
        date : "22 Sep",
        year : "2022",
        title : "Back to School with more free,NEW lessons from EVERFI",
        clientImg : blogClient2,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 6,
        img : blog6,
        img2 : blogList2,
        date : "22 Sep",
        year : "2022",
        title : "The FREE Differentiation Tool for Elementary Reading.",
        clientImg : blogClient3,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 7,
        img : blog7,
        img2 : blogList3,
        date : "22 Sep",
        year : "2022",
        title : "8 Ways to Engage Readers with Readlee’s AI Reading Support",
        clientImg : clientblog,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 8,
        img : blog8,
        img2 : blogList4,
        date : "22 Sep",
        year : "2022",
        title : "12 Ideas from the End of School That Work All Year Long",
        clientImg : blogClient2,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    {
        id : 9,
        img : blog9,
        img2 : blogList1,
        date : "22 Sep",
        year : "2022",
        title : "ISTE Day 0 Recap for my NotatISTE #ISTELive Learning",
        clientImg : clientblog,
        desg : "By.Admin",
        arrow : arroeNerrowRignt,
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets."
    },
    
]